import { SERVICE_TYPE_OPTIONS } from '../constants/ServiceType.js';

function getServiceTypeObject(val) {
    return SERVICE_TYPE_OPTIONS.filter((option) => {
        return option.value === val;
    })[0];
}

export { getServiceTypeObject };
//# sourceMappingURL=getServiceTypeObject.js.map
